module.exports = __webpack_public_path__ + "static/img/icon_94_shangjia.98fe9f04.png";